import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Card';
import toast from 'react-hot-toast';
import { auth } from '../firebaseConfig';
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { FcGoogle } from "react-icons/fc";

const LoginPage = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleGoogleSignIn = async () => {
        setIsSubmitting(true);
        const provider = new GoogleAuthProvider();

        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            if (
                user.email &&
                (user.email.endsWith('@pixie-services.com') || user.email === 'boulkhirm@gmail.com')
            ) {
                // On récupère le prénom depuis le "displayName" fourni par Google
                const firstName = user.displayName ? user.displayName.split(' ')[0] : 'Collaborateur';

                // On affiche la notification de bienvenue personnalisée
                toast.success(`Bienvenue, ${firstName} ! 👋`);

                navigate('/');
            } else {
                await signOut(auth);
                toast.error("Accès refusé. Seuls les comptes autorisés peuvent se connecter.");
            }
        } catch (error) {
            console.error("Erreur lors de la connexion Google:", error);
            toast.error(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="flex items-center justify-center h-full">
            <div className="w-full max-w-sm">
                <Card>
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-pro-dark-text-primary">Matching App</h2>
                        <p className="mt-2 text-sm text-pro-dark-text-secondary">Veuillez vous connecter avec votre compte Google professionnel.</p>
                        <div className="mt-8">
                            <button
                                onClick={handleGoogleSignIn}
                                disabled={isSubmitting}
                                className="w-full inline-flex items-center justify-center gap-3 py-3 px-4 bg-pro-dark-surface border border-pro-dark-border rounded-lg text-pro-dark-text-primary hover:bg-pro-dark-border disabled:opacity-50 transition-colors"
                            >
                                <FcGoogle size={22} />
                                <span className="font-medium">
                                    {isSubmitting ? 'Connexion en cours...' : 'Se connecter avec Google'}
                                </span>
                            </button>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default LoginPage;
